"use strict";

exports.__esModule = true;
exports.TrimRows = exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = void 0;
var _trimRows = require("./trimRows");
exports.PLUGIN_KEY = _trimRows.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _trimRows.PLUGIN_PRIORITY;
exports.TrimRows = _trimRows.TrimRows;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/trimRows/index.js
// module id = 1553
// module chunks = 0